import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Dialog } from 'primereact/dialog';
import { useAppContext } from '../../../AppContext';
import mainAxios from '../../../services/mainAxios';
import PrimeTable from '../../PrimeTable/PrimeTable';
import DateRange from '../../global/DateRange';
import moment from 'moment';
import func from '../../../services/functions';


const ExchangeRateHistory = ({ currency }) => {
    const {
        user: [user],
        selectedCompany: [selectedCompany],
    } = useAppContext();

    const company = user.companiesRights.find(
        (company) => company.id === parseInt(selectedCompany)
    );
    const defaultFilters = {}

    const [filters, setFilters] = useState({
        params: {},
        fromDate: func.getDateFromToday(-6),
        toDate: func.getDateFromToday(1)
    });

    const formatExRateDate = (dateArray) => {
        if (!dateArray) return "";
        const [year, month, day, hour, minute, second] = dateArray;
        return moment({ year, month: month - 1, day, hour, minute, second }).format("DD/MM/YYYY HH:mm:ss");
    };
    const [currencies, setCurrencies] = useState([]);

    const defaultSortCriteria = {
        field: "recordDate",
        direction: "DESC"
    }
    const [tableRows, setTableRows] = useState({
        totalRows: 0,
        rowsPerPage: 10,
        currentPage: 1,

    });

    const { t } = useTranslation("translations");

    useEffect(() => {
        getFilteredResults();
    }, []);

    const getFilteredResults = async ({
        data,
        rowsPerPage = 10,
        currentPage = 1,
        sortCriteria = [defaultSortCriteria]
    } = {}) => {
        const parsedFilters = data ?? filters
        return await mainAxios
            .post("/apiEndpoint/search", {
                object: "ExchangeHistory",
                value: null,
                params: { code: currency.code },
                fromDate: parsedFilters.fromDate,
                toDate: parsedFilters.toDate,
                company: company.id,
                pagination: {
                    pageSize: rowsPerPage,
                    pageNumber: currentPage,
                },
                sortCriteria
            })
            .then((res) => {
                if (res.data.status === true) {
                    setTableRows((tableRows) => ({
                        ...tableRows,
                        totalRows: res?.data?.totalSize,
                    }));
                    setCurrencies(res.data.content);

                }
            });
    };


    const columns = [
        {
            header: "Data",
            field: "recordDate",
            style: { minWidth: "100px", maxWidth: "100px" },
            body: (rowData) => {
                return formatExRateDate(rowData.recordDate);
            },
        },
        {
            header: t("home.exchangeRate"),
            field: "value",
            style: { minWidth: "80px", maxWidth: "80px" },
        },


    ];


    return (
        <>
            <div class="d-flex justify-content-end mb-4 mr-4">
                <DateRange
                    fromDate={filters.fromDate}
                    toDate={filters.toDate}
                    onChange={(dates) => {
                        let fromDate = dates[0];
                        let toDate = dates[1];
                        if (fromDate && toDate) {
                            getFilteredResults({
                                data: {
                                    fromDate,
                                    toDate,
                                    params: { ...filters.params },
                                }
                            });
                        }
                        setFilters((filters) => ({
                            ...filters,
                            fromDate,
                            toDate,
                        }));
                    }}
                />
            </div>
            <PrimeTable
                value={currencies}
                columns={columns}
                defaultFilters={defaultFilters}
                filters={[filters, setFilters]}
                
                onRemoteDataChange={(remoteData) => {
                    const updatedFilters = remoteData.filters ?? filters
                    const updatedTableData = remoteData.tableRows ?? tableRows
                    let { currentPage, rowsPerPage, sortCriteria } = updatedTableData
                    sortCriteria = sortCriteria ? [sortCriteria] : null
                    getFilteredResults({ updatedFilters, rowsPerPage, currentPage, sortCriteria })
                }}
                responsiveLayout="scroll"
                tableRows={[tableRows, setTableRows]}

            />
        </>
    )
}

export default ExchangeRateHistory